import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import CreditCardProfile from './Loadable';

function Card({ authMember })
{
    return (
        <CollapsibleCard
            title="Credit Card Registered"
        >
            <CreditCardProfile memberId={authMember.id} />
        </CollapsibleCard>
    );
}

Card.propTypes = {
    authMember: PropTypes.object,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};

export default connect(mapStateToProps)(Card);
